import { NotificationModal } from 'components/modals/NotificationModal';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';

export const Modals = {
  NotificationModal,
  ConfirmationModal,
};
